import React from 'react';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import Analytics from '../utils/Analytics';
import { SegmentEventTypes } from '../data/tracking';

import { ActionType } from './ActionType.enum';
import { BadgeItem as BadgeItemPropTypes } from './BadgeItem.proptypes';
import { ItemType } from './ItemType.enum';

export const BadgeItem = props => {
	const {
		title,
		badge,
		tagColor,
		showX,
		showTag,
		showBadge,
		showTools,
		showFeatureGate,
		disabled,
		dataqa,
		active,
		toolButtons,
	} = props;

	const className = classNames('badge-item', {
		'badge-item-badge-and-tools': showBadge && showTools,
		'badge-item-badge-only': showBadge && !showTools,
		'badge-item-tools-only': !showBadge && showTools,
		'badge-item-x-icon': showX,
		'badge-item-tag': showTag,
		clickable: disabled !== true,
		disabled: disabled === true,
		active: active === true,
	});

	// call parent's onActionTrigger method
	const raiseActionEvent = event => {
		const { id, onActionTrigger, data = {} } = props;
		const { action: actionType } = event.currentTarget.dataset;
		const subMenuName = event.target.innerText || '';

		onActionTrigger(actionType, ItemType.Badge, { ...data, id });

		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'menubutton',
				field_name_dataqa: `ui-menu-button-${subMenuName}`,
			},
			eventType: SegmentEventTypes.UserInteraction,
		});

		event.stopPropagation();
	};

	const renderToolButtons = () => {
		if (!isEmpty(toolButtons)) {
			return toolButtons.map((ToolButton, index) => (
				<div className="tool" key={index}>
					<ToolButton />
				</div>
			));
		}

		return (
			<>
				<div className="tool">
					<span
						className="pi pi-pencil"
						data-action={ActionType.Edit}
						onClick={raiseActionEvent}
						tabIndex={0}
						role="button"
						aria-label="Edit"
					/>
				</div>
				<div className="tool">
					<span
						className="pi pi-trash"
						key="actiontype"
						data-action={ActionType.Delete}
						onClick={raiseActionEvent}
						tabIndex={0}
						role="button"
						aria-label="Delete"
					/>
				</div>
			</>
		);
	};

	const renderBadge = () => {
		let badgeFormatted = badge;

		if (badge > 999) {
			badgeFormatted = '1k+';
		} else if (badge > 99) {
			badgeFormatted = '99+';
		}

		return (
			<div
				className="badge"
				data-qa={dataqa ? `badge-${dataqa}` : 'badge'}
				{...{ dataqa: dataqa ? `badge-${dataqa}` : 'badge' }}
			>
				{badgeFormatted}
			</div>
		);
	};

	const renderFeatureGate = () => <span className="feature-gate-icon" />;

	return (
		<div
			className={className}
			data-action={ActionType.Click}
			onClick={raiseActionEvent}
			tabIndex={0}
			role="button"
		>
			{(showX || showTag) && (
				<div className="tools-wrapper left">
					{showX ? (
						<div className="tool x-icon visible">
							<i
								className="pi pi-times"
								data-action={ActionType.Delete}
								onClick={raiseActionEvent}
								tabIndex={0}
								role="button"
								aria-label="Delete"
							/>
						</div>
					) : (
						<div className="tag" style={{ backgroundColor: tagColor }} />
					)}
				</div>
			)}
			<div className="menu-item-active-icon" />
			<div
				className="menu-item-text"
				data-qa={dataqa ? `menu-item-${dataqa}` : 'menu-item-text'}
				{...{ dataqa: dataqa ? `menu-item-${dataqa}` : 'menu-item-text' }}
			>
				{showX ? 'Search Results' : title}
				{showFeatureGate && renderFeatureGate()}
			</div>
			{(showTools || showBadge) && (
				<div className="tools-wrapper right">
					{showTools && renderToolButtons()}
					{showBadge && renderBadge()}
				</div>
			)}
		</div>
	);
};

BadgeItem.propTypes = BadgeItemPropTypes;
